export default "__VITE_ASSET__$SjNGxJC__"